const ChipMap = {
    SmallBanner3: {
        id: '260138',
        name: 'SmallBanner3',
        type: 'struct',
        title: '小banner3',
        groupName: 'part4',
    },
    Stars: {
        id: '260139',
        name: 'Stars',
        type: 'struct',
        title: '中外明星',
        groupName: 'part4',
    },
    SmallBanner4: {
        id: '260140',
        name: 'SmallBanner4',
        type: 'struct',
        title: '小banner4',
        groupName: 'part4',
    },
    PlaceList: {
        id: '260141',
        name: 'PlaceList',
        type: 'struct',
        title: '奥运场馆',
        groupName: 'part4',
    }
};

module.exports = { ChipMap };
